module.exports = __webpack_public_path__ + "static/img/video-pass.a12361b1.png";